import { createFileRoute, Outlet } from "@tanstack/react-router";
import NotFoundPage from "@/catchall";
import { RequirePermission } from "@/components/universal/require-permission";

export const Route = createFileRoute("/_private/catalog-product")({
  component: CatalogLayout,
});

function CatalogLayout() {
  return (
    <RequirePermission permission="catalog" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
